import React, { type ReactNode } from 'react';
import StatTile from './StatTile';

export type StatFigure = {
    label: string;
    value: number;
    /** Qualifies this figure, rendered inside its tile. */
    note?: ReactNode;
};

type StatsPanelProps = {
    title: string;
    figures: StatFigure[];
    isLoading: boolean;
    isError?: boolean;
};

const StatsPanel = ({ title, figures, isLoading, isError = false }: StatsPanelProps) => (
    <section className='flex flex-col gap-3' data-testid='stats-panel'>
        <span className='text-xl text-black'>{title}</span>

        {isError ? (
            <p className='text-sm text-grey-70'>These figures could not be loaded. Try again.</p>
        ) : (
            // auto-fit sizes from the container rather than the viewport, so the panel lays out
            // by the width it is given — today a narrow drawer.
            <div className='grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-4'>
                {figures.map(figure => (
                    <StatTile key={figure.label} label={figure.label} value={figure.value} note={figure.note} isLoading={isLoading} />
                ))}
            </div>
        )}
    </section>
);

export default StatsPanel;
